export default function artificialRandomAction(gamePlayerController, aiPackage) {

    switch (gamePlayerController.gamePlayerData.action_status) {
    default:
        // does nothing at the moment.
        break;
    }
}
